import Trips from '../components/views/trip/Trip.vue'
import TripCreate from '../components/views/trip/TripCreate.vue'
import TripDetail from '../components/views/trip/TripDetail.vue'
import TripActivity from '../components/views/trip/TripActivity.vue'
import UpdateDestination from '../components/views/trip/UpdateDestination.vue'
import UpComingTrip from '../components/views/trip/UpComingTrip.vue'
import OnGoingTrip from '../components/views/trip/OnGoingTrip.vue'
import CompletedTrip from '../components/views/trip/CompletedTrip.vue'
const routes = [{
        path: 'trip',
        component: Trips,
        name: 'Trip',
        meta: {
            description: 'List of Think Gas Trips',
            title: 'Trips',
            requiresAuth: true
        }
    },
    {
        path: 'trip/create',
        component: TripCreate,
        name: 'TripCreate',
        meta: {
            description: 'Add a new Trip',
            title: 'Add Trip',
            requiresAuth: true
        }
    },
    {
        path: '/trip/:_id',
        beforeEnter: (to, from, next) => {
            to.params._id === 'create' &&
                (to.params.status === 'ongoing' && to.params.status === 'completed') ?
                next({ name: 'TripCreate' }) :
                next()
        },
        component: TripActivity,
        name: 'TripActivity',
        meta: {
            description: 'Activity log of Trip',
            title: 'Trip Activity',
            requiresAuth: true
        }
    },
    {
        path: '/trip/:_id/status',
        beforeEnter: (to, from, next) => {
            to.params._id === 'create' &&
                (to.params.status === 'scheduled' || to.params.status === 'halt') ?
                next({ name: 'TripCreate' }) :
                next()
        },
        component: TripDetail,
        name: 'TripDetail',
        meta: {
            description: 'Details for the selected trip',
            title: 'Update Trip',
            requiresAuth: true
        }
    },

    {
        path: '/scheduledTrip',
        component: UpComingTrip,
        name: 'UpComing',
        meta: {
            title: 'Scheduled Trips',
            description: 'ThinkGas Scheduled Trips'
        }
    },
    {
        path: '/ongoingTrip',
        component: OnGoingTrip,
        name: 'OnGoing',
        meta: {
            title: 'Ongoing Trips',
            description: 'ThinkGas Ongoing Trips'
        }
    },
    {
        path: '/completedTrip',
        component: CompletedTrip,
        name: 'Completed',
        meta: {
            title: 'Completed Trips',
            description: 'ThinkGas Completed Trips'
        }
    },
    {
        path: 'trip/updateDestination',
        beforeEnter: (to, from, next) => {
            to.params._id === 'create' ? next({ name: 'UpdateDestination' }) : next()
        },
        component: UpdateDestination,
        name: 'UpdateDestination',
        meta: {
            requiresAuth: true
        }
    }
]

export default routes


// WEBPACK FOOTER //
// ./src/routes/trips.route.js